<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card theme="light" rounded="0">
          <v-row>
            <v-col class="pa-8 pa-md-10" cols="12" md="8">
              <v-row v-if="value.title || value.paragraph" justify="center">
                <v-col class="text-center">
                  <TitleParagraphBlock :value="value" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <ContactForm :submit-text="value.action" />
                </v-col>
              </v-row>
            </v-col>

            <v-col
              class="bg-light-blue-darken-2 pa-8 pa-md-10"
              cols="12"
              md="4"
            >
              <v-row justify="end">
                <v-col cols="auto">
                  <HdLogo :opacity="0.4" />
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-body-1">
                  <div class="font-weight-bold">Call Us</div>
                  <div class="mb-4">
                    <a
                      :href="
                        telHref({
                          phone: siteConfig.main_phone
                        })
                      "
                      class="text-white text-decoration-none"
                      target="_blank"
                      >{{ siteConfig.main_phone }}</a
                    >
                  </div>

                  <div class="font-weight-bold">Email Us</div>
                  <div class="mb-4">
                    <a
                      :href="
                        mailToHref({
                          email: siteConfig.info_email,
                          subject: 'Questions'
                        })
                      "
                      class="text-white text-decoration-none"
                      target="_blank"
                      >{{ siteConfig.info_email }}</a
                    >
                  </div>

                  <div class="font-weight-bold">Our Offices</div>
                  <div
                    v-if="
                      siteConfig.main_address && siteConfig.main_address.length
                    "
                    class="mb-4"
                  >
                    <div v-for="(line, i) in siteConfig.main_address" :key="i">
                      {{ line }}
                    </div>
                  </div>

                  <SocialButtons :value="siteConfig.social_info" />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-btn
                    :append-icon="mdiArrowRight"
                    class="text-none"
                    color="primary"
                    exact
                    href="/faqs"
                    rounded="pill"
                    size="large"
                    >Read the FAQs</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { usePageContext } from '#root/renderer/usePageContext'
import { mailToHref, telHref } from '#root/lib/utils'
import { mdiArrowRight } from '@mdi/js'

const { siteConfig } = usePageContext()

defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
